import { useStyles } from '@signavio/ui';
import { jsx as _jsx } from "react/jsx-runtime";
function DataItem({
  active,
  disabled,
  children,
  onClick,
  onMouseEnter
}) {
  const styles = useStyles(defaultStyles, {}, {
    '&active': active,
    '&disabled': disabled
  });
  return (
    /*#__PURE__*/
    // Please fix me
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/interactive-supports-focus
    _jsx("div", {
      ...styles,
      "data-testid": "data-item",
      role: "option",
      "aria-selected": active ? 'true' : 'false',
      "aria-disabled": disabled ? 'true' : 'false',
      onClick: disabled ? undefined : onClick,
      onMouseEnter: disabled ? undefined : onMouseEnter,
      children: children
    })
  );
}
const defaultStyles = ({
  color,
  spacing
}) => ({
  cursor: 'pointer',
  padding: spacing.xxxsmall,
  '&active': {
    backgroundColor: color.mono.ultralight
  },
  '&disabled': {
    opacity: 0.5,
    cursor: 'default'
  }
});
export default DataItem;